"use strict";

require("core-js/modules/es.object.define-property.js");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es.object.to-string.js");

require("core-js/modules/es.regexp.to-string.js");

require("core-js/modules/es.array.slice.js");

require("core-js/modules/es.object.assign.js");

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _cronstrue = _interopRequireDefault(require("cronstrue/dist/cronstrue"));

var _classnames = _interopRequireDefault(require("classnames"));

var _excluded = ["children", "className", "phrase", "verbose", "use24HourTimeFormat"];
var _default = CronFormat;
/**
 * @name CronFormat
 * @desc component. Uses https://www.npmjs.com/package/cronstrue
 */

exports.default = _default;

function CronFormat(_ref) {
  var children = _ref.children,
      className = _ref.className,
      _ref$phrase = _ref.phrase,
      phrase = _ref$phrase === void 0 ? false : _ref$phrase,
      _ref$verbose = _ref.verbose,
      verbose = _ref$verbose === void 0 ? false : _ref$verbose,
      _ref$use24HourTimeFor = _ref.use24HourTimeFormat,
      use24HourTimeFormat = _ref$use24HourTimeFor === void 0 ? true : _ref$use24HourTimeFor,
      rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("span", Object.assign({
    className: (0, _classnames.default)('CronFormat', className)
  }, rest), children ? function () {
    try {
      var readable = _cronstrue.default.toString(children, {
        verbose: verbose,
        use24HourTimeFormat: use24HourTimeFormat
      });

      if (phrase) {
        readable = readable.charAt(0).toLowerCase() + readable.slice(1);
      }

      return readable;
    } catch (er) {
      return 'N/A';
    }
  }() : 'N/A');
}